<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row>


    <el-row v-if="!editMode">
      <el-col :xs="8" :sm="8" :lg="8">
        <el-button type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
        </el-button>
      </el-col>
      <el-col :xs="16" :sm="16" :lg="16" style="text-align: right" v-if="quotationData.status === 'draft'">
        <el-button type="warning" @click.prevent="handleDraft">暫存</el-button>
        <el-button type="primary" @click.prevent="taskFormSave('taskForm')" class="mr-10">產生簽核網址</el-button>
      </el-col>
    </el-row>


    <el-row v-if="!editMode">
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="mr-20">報價單資料</span>
              <span >狀態：</span>
              <el-tag type="success">{{quotationData.status | poStatus}}</el-tag>
            </div>
            <div>

              <el-form class="myform" label-position="top"
                       :model="quotationData">


                <el-row >
                  <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item v-if="quotationData.status === 'review'" label="客戶簽核網址" >
                      <div contenteditable="true">
                        <el-input class="mb-10"   v-model="quotationData.signoffUrl" id="signUrl" autocomplete="off"></el-input>
                        <el-button  type="info" @click.stop.prevent="copyUrl">複製網址</el-button>
                      </div>

                      <el-button  type="info" @click.stop.prevent="openLine">透過 Line 傳網址</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :xs="24" :sm="24" :md="6" >
                    <el-form-item label="報價單號" prop="quotationNo">
                      <el-input readonly v-model="quotationData.quotationNo" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" >
                    <el-form-item label="公司名稱">
                      <el-input readonly v-model="quotationData.customer.company" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" prop="name">
                    <el-form-item label="客戶姓名">
                      <el-input  v-model="quotationData.custName" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" prop="phone1">
                    <el-form-item label="客戶電話">
                      <el-input  v-model="quotationData.custPhone" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :xs="24" :sm="24" :md="6">
                    <el-form-item label="收貨人" prop="shippingUser">
                      <el-input placeholder="收貨人" v-model="quotationData.shippingUser" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="18">
                    <el-form-item label="收貨人電話" prop="shippingUserPhone" >
                      <el-input v-model="quotationData.shippingUserPhone" placeholder="收貨人電話" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :sm="24" :md="18">
                    <el-form-item label="送貨地址" prop="custAddress">
                      <el-input  v-model="quotationData.custAddress" placeholder="送貨地址" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :xs="24" :sm="24" :md="18">
                    <el-form-item label="備註" prop="extraNotes">
                      <el-input  v-model="quotationData.extraNotes" placeholder="備註" autocomplete="off"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                
              </el-form>
            </div>
          </el-card>
      </el-col>
    </el-row>

      <!--    product detail-->
    <el-row v-if="!editMode" >
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20" >
        <el-card class="box-card mycard">
            <div slot="header" class="clearfix">
              <span>報價明細</span>
              <el-button id="add_product_btn" v-if="quotationData.status === 'draft'"
                  style="float: right; padding: 5px 12px" type="primary" class="mr-20"
                  @click.prevent="addProduct">新增產品 <i class="el-icon-s-claim"></i>
                  <!-- @click.prevent="handleProductAdd">新增產品 <i class="el-icon-s-claim"></i> -->
              </el-button>
            </div>
            <div>
              <el-table :data="quotationDetailData" empty-text="無資料" stripe :default-expand-all="true">
                <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="型號" prop="prodModel">
                </el-table-column>
                <el-table-column label="" type="expand" >
                  <template slot-scope="scope">
                    <li>產品: {{scope.row.prodName}}</li>
                    <li class="mt-10">顏色: {{scope.row.prodColor}}</li>
                    <li class="mt-10">牌價: NTD{{scope.row.prodPrice}}</li>
                    <li class="mt-10">數量: {{scope.row.prodQty}}</li>
                    <li class="mt-10">折扣: {{scope.row.discountLabel}}</li>
                    <li class="mt-10">小計: NTD{{scope.row.prodSubTotal}}</li>
                    <li class="mt-10">備註: {{scope.row.prodNotes}}</li>
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="110" v-if="quotationData.status === 'draft'">
                  <template slot-scope="scope">
                    <el-button type="primary" circle @click="handleEdit(scope.row)"><i class="el-icon-edit"></i></el-button>
                    <el-popconfirm
                        class="ml-10 popconfirm-bg"
                        title="確定刪除此筆資料嗎?"
                        confirm-button-text="確定"
                        cancel-button-text="取消刪除"
                        icon="el-iconf-info"
                        icon-color="red"
                        @confirm="handleDelete(scope.row.id)">
                      <el-button type="danger" slot="reference" circle> <i class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
              <el-row>
                <el-col :xs="24" :sm="24" :md="16" class="mt-20">
                  <span>商品加總:</span>
                  NTD{{quotationData.productSum}}
                </el-col>
              </el-row>


              <el-row class="mt-20">
                <el-col :xs="24" :sm="24" :md="4">
                  <span class="mr-20">是否開發票</span>
                  <el-radio-group v-model="quotationData.tax" @change="recalculate" :disabled="checkCaseStatus">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                </el-col>
                <el-col :xs="24" :sm="24" :md="4">
                  <span v-if="quotationData.tax === 1">稅金金額: NTD{{ quotationData.taxPrice }}</span>
                </el-col>
              </el-row>

              <el-row class="mt-10">
                <el-col :xs="24" :sm="24" :md="3" >
                  <el-form class="myform" :model="quotationData"  ref="basicDataForm" label-position="top">
                    <el-form-item label="運費" prop="shippingFee">
                      <el-input-number v-model="quotationData.shippingFee" :min="0"  :max="200"
                                 @change="recalculate"></el-input-number>

                      <!-- <el-input v-model="quotationData.shippingFee" autocomplete="off" @blur="recalculate"></el-input> -->
                    </el-form-item>
                    <el-form-item label="活動折扣" prop="eventDiscount">
                      <el-input-number v-model="quotationData.eventDiscount" :max="0"
                                 @change="recalculate"></el-input-number>

                      <!-- <el-input v-model="quotationData.eventDiscount" autocomplete="off" @blur="recalculate"></el-input> -->
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>

              <el-row>
                <el-col :xs="24" :sm="24" :md="16" class="mt-20">
                  <el-tag type="warning" effect="dark"><span>總計:</span>
                  NTD{{quotationData.totalPrice}}</el-tag>
                </el-col>
              </el-row>

            </div>
          </el-card>
      </el-col>
    </el-row>


   
    <el-row v-if="!editMode">
      <el-col :xs="24" :sm="24" :md="24" class="mt-20">
        <el-card class="box-card">
         <el-form class="myform" label-position="top"
                       :model="quotationData"
                       :rules="taskFormRule"
                      ref="taskForm">
          <el-form-item label="注意事項" prop="notes">
            <el-input ref="qNotes" type="textarea" rows="16" v-model="quotationData.notes" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      </el-col>
       <!-- <el-button v-if="quotationData.status === 'draft'" type="primary" @click.prevent="selectNotes" class="mr-20 mt-20">挑選常用注意事項
      </el-button> -->
    </el-row>

    <!-- 匯款資訊 -->
    <el-row v-if="!editMode">
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
         <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>匯款資訊</span>
            </div>
            <el-radio-group v-model="quotationData.wireInfo" :disabled="checkCaseStatus">
              <el-radio label="台北">台北</el-radio>
              <el-radio label="台中">台中</el-radio>
              <el-radio label="高雄">高雄</el-radio>
            </el-radio-group>
          </el-card>
          <el-card class="box-card">
            <div v-if="quotationData.wireInfo === '台北'">
              <p>-台北服務處 匯款資訊 -</p>
              <p class="mt-10">銀行：中國信託銀行（822）</p>
              <p class="mt-10">戶名：立壕有限公司</p>
              <p class="mt-10">帳號：266 118 171 005</p>
              <p class="mt-10">分行：新莊分行</p>
            </div>
            <div v-if="quotationData.wireInfo === '台中'">
              <p>-台中服務處 匯款資訊 -</p>
              <p class="mt-10">銀行：中國信託銀行（822）</p>
              <p class="mt-10">戶名：立壕有限公司</p>
              <p class="mt-10">帳號：266 540 007 158</p>
              <p class="mt-10">分行：新莊分行</p>
            </div>
            <div v-if="quotationData.wireInfo === '高雄'">
              <p>-高雄服務處 匯款資訊 -</p>
              <p class="mt-10">銀行：中國信託銀行（822）</p>
              <p class="mt-10">戶名：立壕有限公司</p>
              <p class="mt-10">帳號：266 540 308 158</p>
              <p class="mt-10">分行：新莊分行</p>
            </div>
          </el-card>
      </el-col>
    </el-row>

    <!-- 簽名檔資訊 -->
    <el-row v-if="!editMode">
      <el-col :xs="24" :sm="24" :lg="24" v-if="quotationData.status === 'confirm'" class="mt-20">
         <el-card class="box-card" id="sign-card">
            <div slot="header" class="clearfix">
              <span>簽名檔</span>
              <el-button  style="float: right;padding: 0px 0" type="text">簽回日期　:　{{quotationData.signDate | fmtDateTime}}</el-button>
            </div>
            <div>
              <el-image
                  style="width: 100%; "
                  :src="quotationData.signFile"
                  fit="fit"></el-image>
              <!-- <img ref="img" :src="quotationData.signFile" id="canvas-image"> -->
            </div>
          </el-card>
      </el-col>
    </el-row>

    <!-- 商品新增表單 -->
    <el-row v-if="editMode" style="background-color: white; padding:20px">
      <!-- <el-dialog title="商品資訊"
                 :visible.sync="dialogProductFormVisible"
                 :width="dw"
                 @close="resetForm('prodForm')"
                 fullscreen="true"> -->

        <el-form class="myform" id="prodInputForm" :model="prodForm" label-position="top" ref="prodForm" label-width="100px" :rules="prodFormRules">
          <el-row>
            <el-col :xs="24" :sm="24" :md="12">
              <el-form-item label="商品" prop="prodLabel" style="width: 100%;">
                 <el-autocomplete 
                  :disabled="prodForm.actionMode == 'update'"
                  class="inline-input full-width-input"
                  v-model="prodForm.prodLabel"
                  :fetch-suggestions="queryProduct"
                  placeholder="輸入商品名稱"
                  :trigger-on-focus="false"
                  @select="handleSelectProduct"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :xs="24" :sm="24" :md="12">
              <el-form-item label="顏色" prop="prodColor">
                <el-select
                  :disabled="prodForm.actionMode == 'update'"
                    v-model="prodForm.selectedColor"
                    :multiple="false"
                    placeholder="請選顏色"
                    @change="handleSelectColor">
                  <el-option
                      v-for="(c,idx) in colorOptions"
                      :key="c.idx"
                      :label="c.text"
                      :value="c.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" v-if="prodForm.selectedColor === 'custom_color'">
              <el-form-item label="客製顏色" prop="prodCustomColor">
                  <el-input :disabled="prodForm.actionMode == 'update'" v-model="prodForm.prodCustomColor" placeholder="請輸入顏色"></el-input>
              </el-form-item>
            </el-col>

          </el-row>

          <el-row>


            <el-col :xs="24" :sm="24" :md="12">
              <el-form-item label="牌價" prop="prodPrice">
                <el-input  v-model="prodForm.prodPrice" @blur="subTotalCalculate"></el-input>
              </el-form-item>
            </el-col>

          </el-row>

          <el-row>
            <el-col :xs="24" :sm="24" :md="12">
              <el-form-item label="請選折扣" prop="prodPriceDiscount">
                <el-select
                    v-model="prodForm.prodPriceDiscount"
                    :multiple="false"
                    placeholder="請選折扣"
                    @change="discountChange">
                  <el-option
                      v-for="(c,idx) in discountOptions"
                      :key="c.idx"
                      :label="c.text"
                      :value="c.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12">
              <el-form-item label="數量" prop="prodQty">
                <el-input-number v-model="prodForm.prodQty"  :max="1000"
                                 @change="subTotalCalculate"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24" :md="12">
              <el-form-item label="小計" prop="prodSubTotal">
                <el-input readonly v-model="prodForm.prodSubTotal"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="商品備註" prop="prodNotes">
                <el-input type="textarea" v-model="prodForm.prodNotes"></el-input>
              </el-form-item>
            </el-col>
          </el-row>


        </el-form>

        <div style="float: right;">
          <el-button @click.prevent="cancelAddProduct">取 消</el-button>
          <el-button type="primary" @click="saveProduct('prodForm')">確 定</el-button>
        </div>

      <!-- </el-dialog> -->
    </el-row>


      <!-------------------------------------------------------------------->
      <!-- dialog -->
      <!-------------------------------------------------------------------->

    <el-row>
      <el-dialog class="mydialog"  title="常用備註"
                 :visible.sync="notesDialog"
                 :width="dw" :fullscreen="true">

        <el-table :data="notesTableData"
                  empty-text="無資料"
                  stripe header-row-class-name="headerStyle"
                  @selection-change="handleSelectNotes">

          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="value" label="備註">
          </el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button @click="notesDialog = false">取 消</el-button>
          <el-button type="primary" @click="saveNotes">確 定</el-button>
        </div>
      </el-dialog>
    </el-row>



  </div>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import dayjs from "dayjs"
import VueSrollTo from 'vue-scrollto'

export default {

  name: "QuotationDetail",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請選客戶'))
      } else {
        callback()
      }
    }
    let checkSelect = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請選產品'))
      } else {
        callback()
      }
    }
    let checkPrice = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('價格不得為空'))
      } else {
        callback()
      }
    }
    let checkEmpty = (rule, value, callback) => {
      console.log('checkEmpty:', value, rule)
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('此欄位不可為空'))
      } else {
        callback()
      }
    }
    let fieldRequired = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }


    return {
      editMode: false,

      task: {
        form: {
          itemContent: '',
          itemPrice:0
        }
      },

      dw: '60%',
      dialogProductFormVisible: false,
      dialogFormVisible: false,
      notesDialog: false,
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 15,
      total: 0,
      notesTableData:[],
      quotationId: '',
      productData: [],
      options: [],
      basicForm: {
        status: ''
      },
      form: {
        quoationDate: '',
        custId: ''
      },
      prodOptions: [],
      notesChecked: [],
      colorOptions: [],
      prodForm: {
        quotationId: '',
        prodLabel: '',
        prodId: '',
        prodName: '',
        prodQty: 0,
        prodPrice: 0,
        prodPriceDiscount: "1.0",
        prodSubTotal: 0,
        prodNotes: '',
        discount:1,
        discountLabel: '無折扣',
        tax: 'N',
        prodColor:'',
        selectedColor: '',
        prodCustomColor:'',
        prodModel:'',
        actionMode: ''
      },
      discountOptions: [],

      quotationData: {
        status:'',
        shippingDate:'',
        custAddress:'',
        notes:'',
        customer: {},
        owner: {},
        tax: 0,
        taxPrice: 0,
        totalPrice: 0,
        productSum: 0,
        shippingFee: 0,
        shippingUser:'',
        shippingUserPhone:'',
        wireInfo: '台北',
        eventDiscount:0,
        custName:'',
        custPhone:''
      },

      quotationDetailData: [],
      basicDataFormRule: {
        "notes" : [{ required: true, validator: checkEmpty, trigger: 'change' }],
        "customer.name": [{ required: true, validator: checkEmpty, trigger: 'change' }],
        "customer.phone1": [{ required: true, validator: checkEmpty, trigger: 'change' }]
      },
      prodFormRules: {
        prodId: [{required: true, validator: checkSelect, trigger: 'change'}],
        prodPrice: [{required: true, validator: checkPrice, trigger: 'change'}],
        prodLabel: [{required: true, validator: checkSelect, trigger: 'change'}]
      },
      taskFormRule:{
        notes : [{required:true, validator: fieldRequired, trigger: 'change'}]
      }
    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
    showSignUrl(){
      return process.env.VUE_APP_SIGNOFF_SERVER + '#/sign/po/' + this.quotationData.uuid
    },
    checkCaseStatus(){
      if(this.quotationData.status === 'draft') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {

    taskFormSave(formName){
      this.$refs[formName].validate( valid => {

        console.log('valid:', valid)

        if (valid) {
          this.$confirm('請確認報價內容是否正確無誤? 送出後會產生客戶簽核網址，並且此報價單將不能再修改。', '提醒', {
            confirmButtonText: '確定無誤',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {

            this.quotationData.status = "review"
            this.request.post("/quotation/generate/signoff", this.quotationData).then(res => {
              if (res.code === '200') {
                this.showResult('success', '簽核網址產生成功.')
                this.loadQuotation()
              } else {
                this.showResult('error', '簽核網址產生失敗.')
              }
            })

          }).catch((e) => {
              console.log("e:", e)
              this.showResult('error', e)
          });

        } else {
          this.$nextTick(()=>{
            this.$refs['qNotes'].focus()
            this.showResult('error', '訂單注意事項未填寫')
          })

        }

      })
    },

    scrollStart() {
      console.log('scrollStart')
      this.editMode = false

    },
    addProduct() {
      this.editMode = true

      this.$nextTick(()=>{

        document.getElementById("prodInputForm").scrollIntoView({behavior: 'smooth', inline:'nearest'})

        this.prodForm.prodLabel = ''
        this.prodForm.prodQty = 1
        this.prodForm.prodPrice = 0
        this.prodForm.prodNotes = ''
        this.prodForm.selectedColor = ''

      })
    },


    cancelAddProduct(){
      this.editMode = false
      this.$nextTick(()=>{
        document.getElementById("add_product_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })
    },
    recalculate(){
      let productSum = this.quotationData.productSum

      let tax = 0
      if(this.quotationData.tax === 1) {
        tax = 0.05
      }

      this.quotationData.taxPrice = Math.round(productSum * tax)
      console.log('taxPrice:', this.quotationData.taxPrice)

      this.quotationData.totalPrice = parseInt(productSum) + parseInt(this.quotationData.taxPrice) + parseInt(this.quotationData.shippingFee) + parseInt(this.quotationData.eventDiscount)


    },
    handleSelectNotes(val) {
      this.notesChecked = val
    },

    handleCurrentChange(val) {
      this.pageNum = val
      // this.loadData()
    },
    search() {

    },
    clearQuery() {
      this.keyword = ''
      this.queryField = ''
      // this.loadData()
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.quoationDate = dayjs().format("YYYYMMDD")
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = '400'; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%"
      }
    },
    loadQuotation() {
      this.request.get("/quotation/" + this.quotationId).then(res => {
        if (res.code === '200') {
          this.quotationData = res.data

          if (res.data.custAddress === null || res.data.custAddress === '') {
            if (res.data.customer != null) {
              this.quotationData.custAddress = res.data.customer.address
            } else {
              this.quotationData.custAddress = ''
            }
          }

          if (res.data.wireInfo === null || res.data.wireInfo === '') {
            this.quotationData.wireInfo = '台北'
          }

          //
          //this.quotationData.customer.name = ""
          //this.quotationData.customer.phone1 = ""

        } else {
          this.showResult('error', res.message)
        }
      })
    },
    loadQuotationProduct() {
      this.request.get("/quotation/product/detail/" + this.quotationId).then(res => {
        if (res.code === '200') {
          this.quotationDetailData = res.data
          let initPrice = 0

          this.quotationDetailData.forEach(obj => {
            console.log(obj.prodSubTotal)
            initPrice += obj.prodSubTotal
          })

          //產品加總
          this.quotationData.productSum = initPrice

          this.recalculate()


        } else {
          this.showResult('error', res.message)
        }
      })
    },
    saveData(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // console.log('form:', this.form)
          this.request.post("/quotation/init", this.form).then(res => {
            this.$router.push("/quotation/detail/" + res.data.id)
          })
        }
      })
    },
    goBack() {
      this.$router.push('/daily/quotation')
    },
    handleDraft() {
      console.log('this.quotationData:', this.quotationData)
      this.request.post("/quotation", this.quotationData).then(res => {
          if (res.code === '200') {
            this.showResult('success', '資料儲存成功')
            this.loadQuotation()
            this.loadQuotationProduct()
          } else {
            this.showResult('error', '資料儲存失敗')
          }
      })
    },
    handleSign() {

      this.$refs['basicDataForm'].validate( valid => {

        console.log('valid:', valid)

        if (valid) {
          this.$confirm('請確認報價內容是否正確無誤? 送出後會產生客戶簽核網址，並且此報價單將不能再修改。', '提醒', {
            confirmButtonText: '確定無誤',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {

            this.quotationData.status = "review"
            this.request.post("/quotation/generate/signoff", this.quotationData).then(res => {
              if (res.code === '200') {
                this.showResult('success', '簽核網址產生成功.')
                this.loadQuotation()
              } else {
                this.showResult('error', '簽核網址產生失敗.')
              }
            })

          }).catch((e) => {
            console.log("confirmButtonText catch:", e)
          });

        }
      })


    },
    handleDelete(id) {
      this.request.delete("/quotation/product/detail/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadQuotationProduct()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    handleProductAdd() {
      this.dialogProductFormVisible = true
    },
    saveProduct(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {

          if (this.prodForm.selectedColor === 'custom_color') {
            this.prodForm.prodColor = this.prodForm.prodCustomColor
          }

          this.request.post("/quotation/detail", this.prodForm).then(res => {
            if (res.code === '200') {
              // this.dialogProductFormVisible = false
              this.editMode = false
              this.prodForm.actionMode = ''
              this.$nextTick(()=>{
                document.getElementById("add_product_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                this.loadQuotationProduct()
                this.showResult("success", "產品項目更新成功")
              })


            } else {
              this.showResult("error", "產品項目更新失敗")
            }
          })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },

    loadProduct() {
      this.request.get("/product/query?keyword=").then(res => {
        if (res.code === '200') {
          this.prodOptions = res.data
        }
      })
    },
    showPrice() {
      const selectedId = this.prodForm.prodId
      const found = this.prodOptions.find(e => e.id == selectedId)


      this.prodForm.prodPrice = found.price
      this.prodForm.prodSubTotal = parseInt(found.price) * parseInt(this.prodForm.prodQty)

      // console.log('showPrice prodSubTotal:', this.prodForm.prodSubTotal)
      // console.log('showPrice discountLabel:', this.prodForm.discountLabel)
      // console.log('showPrice discount:', this.prodForm.discount)

      this.prodForm.prodName = found.name
      this.prodForm.prodNotes = found.notes
      this.prodForm.prodColor = found.color
    },
    discountChange(val){

      let obj = {}
      obj = this.discountOptions.find( item => { return item.value === val})

      console.log("discountChange:", obj)

      this.prodForm.discountLabel = obj.text
      this.prodForm.discount = obj.value

      this.subTotalCalculate()
    },
    subTotalCalculate() {

      let unit_price = this.prodForm.prodPrice
      let qty = this.prodForm.prodQty

      console.log("牌價:", unit_price)
      console.log("數量:", qty)
      console.log("折扣 discountLabel:", this.prodForm.discountLabel)
      console.log("折扣1:", this.prodForm.discount)
      console.log("折扣1:", this.prodForm.prodPriceDiscount)

      if (this.prodForm.prodPriceDiscount === '1.0' || this.prodForm.prodPriceDiscount === '1') {
          this.prodForm.prodSubTotal = Math.round(unit_price * qty)
      } else {
          let final_discount = 1 - parseFloat(this.prodForm.prodPriceDiscount)
      console.log("折扣2:", final_discount)

          let temp = final_discount.toFixed(2);
          this.prodForm.discount = temp

          console.log("折扣3:", temp)

          this.prodForm.prodSubTotal = Math.round(unit_price * temp * qty)
      }



      console.log("最後:", this.prodForm.prodSubTotal)

    },
    copyUrl() {
      let urlToCopy = document.querySelector('#signUrl')
      urlToCopy.select()
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        this.showResult("success", "網址已複製")
      } catch (err) {
        this.showResult("error", "網址複製失敗")
      }
      window.getSelection().removeAllRanges()
    },
    openLine() {
      window.open(`http://line.naver.jp/R/msg/text/?${this.quotationData.signoffUrl}`)

    },

    queryProduct(str, cb){
      this.request.get("/product/q?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.model + ' ' + item.name,
              id: item.model
            }
          })
          cb(list)
        }
      })
    },

    handleSelectProduct(item) {
      console.log('handleSelectProduct:', item)



      this.request.get("/product/model?keyword=" + item.id).then(res => {

        if (res.code === '200') {
          console.log('handleSelectProduct:', res.data)
          //this.colorOptions = res.data
          this.prodOptions = res.data

          //先設定產品名，避免選顏色時是選客製，這樣會帶不出產品資料
          if (this.prodOptions.length > 0) {
            let p = this.prodOptions[0]
            this.prodForm.prodName = p.name
            this.prodForm.prodModel = p.model
          }

          let list = res.data.map((item) => {
            return {
              value: item.id,
              text: item.color
            }
          })
          list.push({value:'custom_color', text:'其它'})
          this.colorOptions = list
        }
      })

      // this.prodForm.prodId = item.id
      // this.showPrice()
      // this.subTotalCalculate()
    },

    handleSelectColor() {
      console.log(this.prodForm.selectedColor)
      if (this.prodForm.selectedColor === 'custom_color') {
        this.prodForm.prodPrice = ''
        this.prodForm.prodSubTotal = 0
        this.prodForm.prodId = 0
      } else {
        this.prodForm.prodId = this.prodForm.selectedColor
        //this.prodForm.selectedColor = ''
        this.showPrice()
        this.subTotalCalculate()
      }
    },

    prepareDiscountList() {
      this.discountOptions = [
        { value:"1.0", text:"無折扣"},
        { value:"0.01", text:"99折"},
        { value:"0.02", text:"98折"},
        { value:"0.03", text:"97折"},
        { value:"0.04", text:"96折"},
        { value:"0.05", text:"95折"},
        { value:"0.06", text:"94折"},
        { value:"0.07", text:"93折"},
        { value:"0.08", text:"92折"},
        { value:"0.09", text:"91折"},
        { value:"0.1", text:"9折"},
        { value:"0.11", text:"89折"},
        { value:"0.12", text:"88折"},
        { value:"0.13", text:"87折"},
        { value:"0.14", text:"86折"},
        { value:"0.15", text:"85折"},
        { value:"0.16", text:"84折"},
        { value:"0.17", text:"83折"},
        { value:"0.18", text:"82折"},
        { value:"0.19", text:"81折"},
        { value:"0.2", text:"8折"},
        { value:"0.21", text:"79折"},
        { value:"0.22", text:"78折"},
        { value:"0.23", text:"77折"},
        { value:"0.24", text:"76折"},
        { value:"0.25", text:"75折"},
        { value:"0.26", text:"74折"},
        { value:"0.27", text:"73折"},
        { value:"0.28", text:"72折"},
        { value:"0.29", text:"71折"},
        { value:"0.3", text:"7折"},
        { value:"0.31", text:"69折"},
        { value:"0.32", text:"68折"},
        { value:"0.33", text:"67折"},
        { value:"0.34", text:"66折"},
        { value:"0.35", text:"65折"},
        { value:"0.36", text:"64折"},
        { value:"0.37", text:"63折"},
        { value:"0.38", text:"62折"},
        { value:"0.39", text:"61折"},
        { value:"0.4", text:"6折"},
        { value:"0.41", text:"59折"},
        { value:"0.42", text:"58折"},
        { value:"0.43", text:"57折"},
        { value:"0.44", text:"56折"},
        { value:"0.45", text:"55折"},
        { value:"0.46", text:"54折"},
        { value:"0.47", text:"53折"},
        { value:"0.48", text:"52折"},
        { value:"0.49", text:"51折"},
        { value:"0.5", text:"5折"},
        { value:"0.51", text:"49折"},
        { value:"0.52", text:"48折"},
        { value:"0.53", text:"47折"},
        { value:"0.54", text:"46折"},
        { value:"0.55", text:"45折"},
        { value:"0.56", text:"44折"},
        { value:"0.57", text:"43折"},
        { value:"0.58", text:"42折"},
        { value:"0.59", text:"41折"},
        { value:"0.6", text:"4折"},
        { value:"0.61", text:"39折"},
        { value:"0.62", text:"38折"},
        { value:"0.63", text:"37折"},
        { value:"0.64", text:"36折"},
        { value:"0.65", text:"35折"},
        { value:"0.66", text:"34折"},
        { value:"0.67", text:"33折"},
        { value:"0.68", text:"32折"},
        { value:"0.69", text:"31折"},
        { value:"0.7", text:"3折"},
        { value:"0.71", text:"29折"},
        { value:"0.72", text:"28折"},
        { value:"0.73", text:"27折"},
        { value:"0.74", text:"26折"},
        { value:"0.75", text:"25折"},
        { value:"0.76", text:"24折"},
        { value:"0.77", text:"23折"},
        { value:"0.78", text:"22折"},
        { value:"0.79", text:"21折"},
        { value:"0.8", text:"2折"},
        { value:"0.81", text:"19折"},
        { value:"0.82", text:"18折"},
        { value:"0.83", text:"17折"},
        { value:"0.84", text:"16折"},
        { value:"0.85", text:"15折"},
        { value:"0.86", text:"14折"},
        { value:"0.87", text:"13折"},
        { value:"0.88", text:"12折"},
        { value:"0.89", text:"11折"},
        { value:"0.9", text:"1折"}
      ]
    },
    selectNotes() {
      this.notesDialog = true
      let req = '/dic/type?queryField=quotation_notes'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.notesTableData = res.data
        }
      })

    },
    saveNotes() {
      let ids = this.notesChecked.map(v => v.value)

      console.log(ids)
      console.log('this.quotationData.notes:', this.quotationData.notes)

      if (this.quotationData.notes === null || this.quotationData.notes === '') {
        this.quotationData.notes = ids.join("\n")
      } else {
        this.quotationData.notes = this.quotationData.notes + '\n' + ids.join("\n")
      }
      console.log('this.quotationData.notes:', this.quotationData.notes)
      this.notesDialog = false
    },

    loadQuotationNotes() {
      let req = '/dic/type?queryField=quotation_notes'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          let all_notes = res.data.map(v => v.value)

         this.quotationData.notes = all_notes.join("\n")
        }
      })
    },
    handleEdit(rowData) {
      this.editMode = true

      this.prodForm = rowData
      this.prodForm.actionMode = 'update'
      this.prodForm.prodLabel = this.prodForm.prodModel + " " + this.prodForm.prodName
      this.prodForm.selectedColor = this.prodForm.prodColor
      if (this.prodForm.discount == "1") {
        this.prodForm.discount == "1.0"
      }
      let found = this.discountOptions.find( opt => opt.text === this.prodForm.discountLabel)
      this.prodForm.prodPriceDiscount = found.value
      

      this.$nextTick(()=>{

        document.getElementById("prodInputForm").scrollIntoView({behavior: 'smooth', inline:'nearest'})

        // this.prodForm.prodLabel = ''
        // this.prodForm.prodQty = 1
        // this.prodForm.prodPrice = 0
        // this.prodForm.prodNotes = ''
        // this.prodForm.selectedColor = ''

      })

      
    },

  },
  filters: {},
  mounted() {
    this.quotationId = this.$route.params.quotationId
    this.prodForm.quotationId = this.$route.params.quotationId

    this.loadQuotation()

    this.loadQuotationProduct()

    this.loadQuotationNotes()

    this.prepareDiscountList()

    this.setDialogWidth();


  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.full-width-input {
  width: 95%;
  max-width: 100%;
}

.myform >>> .el-form-item__label {
  padding: 0;
}
.mydialog >>> .el-dialog__body {
  padding: 0px;
}
.mydialog >>> .el-table {
  padding: 0px 4px;
}
.el-form-item {
  margin-bottom: 10px;
}
.el-table {
  padding: 0;
}
.myform >>> .el-form--label-top .el-form-item__label {
  padding: 0 !important;
}


.mycard >>> .el-card__body {
 padding: 20px 10px 20px 20px;
}

</style>
